import { Box, Typography } from '@mui/material';

import { COLORS } from './constants';

export const Section = ({ title, id, children, sx }) => (
  <Box component="section" aria-labelledby={id} sx={{ mt: { xs: 4, tl: 5 }, ...sx }}>
    <Typography id={id} variant="h2" sx={{ fontSize: { xs: 20, tl: 24 }, fontWeight: 700, mb: 2 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

export const Card = ({ children, sx, ...rest }) => (
  <Box
    sx={{
      backgroundColor: COLORS.card,
      border: `1px solid ${COLORS.border}`,
      borderRadius: 2,
      p: { xs: 2, tl: 3 },
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

// Colored dot plus text; status is always carried by the label, never color alone.
export const StatusChip = ({ label, tone = 'neutral' }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.75,
      fontSize: 13,
      fontWeight: 600,
      px: 1,
      py: 0.25,
      borderRadius: 1,
      border: `1px solid ${COLORS[tone] || COLORS.neutral}`,
    }}
  >
    <Box
      component="span"
      aria-hidden="true"
      sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: COLORS[tone] }}
    />
    {label}
  </Box>
);

export const MeterBar = ({ value, max = 100, label, valueText, color = COLORS.accent }) => {
  const safeValue = Number.isFinite(value) ? Math.max(0, Math.min(max, value)) : 0;
  const pct = Math.max(0, Math.min(100, (safeValue / max) * 100));
  return (
    <Box
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={Math.round(safeValue * 10) / 10}
      aria-valuetext={valueText}
      sx={{ height: 8, borderRadius: 4, backgroundColor: 'rgba(255,255,255,0.12)' }}
    >
      <Box sx={{ width: `${pct}%`, height: '100%', borderRadius: 4, backgroundColor: color }} />
    </Box>
  );
};
